<script lang="ts">
	import type { StructuredData } from '$lib/config/seo';

	let { schemas = [] }: { schemas: StructuredData[] } = $props();

	const SCRIPT_CLOSE = '</' + 'script>';

	function serialize(schema: StructuredData): string {
		return '<script type="application/ld+json">' + JSON.stringify(schema).replace(/<\//g, '<\\/') + SCRIPT_CLOSE;
	}
</script>

<svelte:head>
	{#each schemas as schema, i (i)}
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html serialize(schema)}
	{/each}
</svelte:head>